import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	chatInputActionsButtonsTooltip: {
		id: 'ai-mate.chat-input.open-chat-input-buttons-tooltip',
		defaultMessage: 'Add',
		description: 'Tooltip for Add a resource menu button',
	},
	mentionTypeAheadButtonLabel: {
		id: 'ai-mate.chat-input.mention-type-ahead-button.label',
		defaultMessage: 'Mention someone',
		description: 'Label for the mention type ahead button',
	},
	linkTypeAheadButtonLabel: {
		id: 'ai-mate.chat-input.link-type-ahead-button.label',
		defaultMessage: 'Add a link',
		description: 'Label for the link type ahead button',
	},
	addContentButtonLabel: {
		id: 'ai-mate.chat-input.add-content-button.label',
		defaultMessage: "Use what you're viewing as context",
		description: 'Label for the add current page as context button',
	},
	addMoreFormattingButtonLabel: {
		id: 'ai-mate.chat-input.add-more-formatting-button.label',
		defaultMessage: 'More formatting',
		description: 'Label for the more formatting button',
	},
	addCurrentPageAsContextDisabledTooltip: {
		id: 'ai-mate.chat-input.add-current-page-as-context-disabled-tooltip',
		defaultMessage: "This page isn't supported yet",
		description: 'Tooltip for the add current page as context button when disabled',
	},
	discoverSkillsButtonLabel: {
		id: 'ai-mate.chat-input.discover-skills-button.label',
		defaultMessage: 'View all skills',
		description: 'Label for the view all skills button',
	},
});
